import { Injectable } from '@angular/core';
import { ApiService } from '../services/api.service';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '../common/models/common.model';
import {
  FormulationType,
  FormulationTypeRequest,
  PackagingType,
  Product,
  ProductCategoryObject,
  ProductNameList,
  ProductWritePayload,
} from './product.model';
import { buildHttpParams } from '../utils';

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private _baseUrl: string = 'products';

  constructor(private _apiService: ApiService) {}

  list(query: Record<string, string> | null = null): Observable<PaginatedResponse<Product>> {
    const params = buildHttpParams(query);
    return this._apiService.get(this._baseUrl + '/', params);
  }

  get(id: string): Observable<Product> {
    return this._apiService.get(this._baseUrl + '/' + id + '/');
  }

  delete(id: string): Observable<void> {
    return this._apiService.delete(`${this._baseUrl}/${id}/`);
  }

  post(reqBody: any): Observable<Product> {
    return this._apiService.post(`${this._baseUrl}/`, reqBody);
  }

  patch(id: string, reqBody: any): Observable<Product> {
    return this._apiService.patch(`${this._baseUrl}/${id}/`, reqBody);
  }

  public lighter_list(companyId?: string): Observable<ProductNameList[]> {
    const params = buildHttpParams(companyId ? { company: companyId } : null);
    return this._apiService.get(this._baseUrl + '/lighter_list/', params);
  }

  public listFormulationTypes(): Observable<FormulationType[]> {
    return this._apiService.get('formulation-types/');
  }

  public createFormulationType(
    payloadOrLabel: FormulationTypeRequest | string,
    key?: string
  ): Observable<FormulationType> {
    const payload: FormulationTypeRequest =
      typeof payloadOrLabel === 'string' ? { label: payloadOrLabel, key: key || payloadOrLabel } : payloadOrLabel;
    return this._apiService.post('formulation-types/', payload);
  }

  public packaging_types(): Observable<PackagingType[]> {
    return this._apiService.get('packaging-types/');
  }

  public createPackagingType(name: string, description: string = ''): Observable<PackagingType> {
    return this._apiService.post('packaging-types/', { name, description });
  }

  public deletePackagingType(id: string): Observable<void> {
    return this._apiService.delete(`packaging-types/${id}/`);
  }

  public listCategories(): Observable<ProductCategoryObject[]> {
    return this._apiService.get('product-categories/');
  }

  public createCategory(name: string, description: string = ''): Observable<ProductCategoryObject> {
    return this._apiService.post('product-categories/', { name, description });
  }

  public deleteCategory(id: string): Observable<void> {
    return this._apiService.delete(`product-categories/${id}/`);
  }

  export(): Observable<Blob> {
    return this._apiService.getBlob('products/export/');
  }
}
